import React, { Component, useState, useEffect  } from "react";
import { useNavigate, Navigate, useLocation } from "react-router-dom";
import queryString from 'query-string';
const CryptoJS = require("crypto-js");
//import { useNavigate, useLocation } from 'react-router-dom'





let resturl='https://borderforceapps.gov.tc/';
let customspremurl='https://customsprem.gov.tc/';


const queryStringParams = queryString.parse(window.location.search);
if (queryStringParams.drv!=undefined){
	/*
	can test the production
	*/
	resturl='http://127.0.0.1:3001/';
	customspremurl='http://127.0.0.1:3001/';
	console.log('resturl: '+resturl);
	console.log('customspremurl: '+customspremurl);
	
	//console.log('queryStringParams: '+resturlJSON.stringify(queryStringParams));
	}//end if
	

function LoginPage() {
var md5 = require('md5');

const location = useLocation();
const navigate = useNavigate();
   
const [dowait, setDowait] = useState({show:false});
const [attemp, setAttemp] = useState({count:0});

const [Logininfo, setLogininfo] = useState({});

 
const [cred, setCred] = useState({
email: ""
, pwd: ""
, forgotpwd: 0
, trust_this_device: 0
, eml_ver_code: ""
//eml_ver_code_sent replaces otpsent
, eml_ver_code_sent:false
, isemail:false
, ip:""
, auth_count:null
, fail_count:null
, trustcount:0
, devicename:""
, aduser:""
, match_count:null
, browser_name:""
, changepassword:false
});		

const [myprofile, setMyprofile] = useState({password1:"", password2:""});
const [pwd, setPwd] = useState({
	req1:false
	,req2:false
	,req3:false
	,req4:false
	,req5:false
	,req6:false
	});
	
useEffect(() => {
	
	document.title =   "APS Login";	
	
	//logout(sessionStorage.getItem("USERNAME"));
	getDeviceName();
	getBrowserName();
	getip();
	sessionStorage.setItem("API_ERR_MSG", "an error occured.  please try again or contact admin");

	const ATTEMPT_COUNT=sessionStorage.getItem("ATTEMPT_COUNT")??0;
	if (1*ATTEMPT_COUNT>0)
		setAttemp({count:ATTEMPT_COUNT});

//	if (queryStringParams.lnl)
	//	handleSubmit(null);
//getcaptchaimg();
	const logout=location.state?(location.state.logout??false):false;
	console.log("logout: "+logout);
	if (logout==true){
		sessionStorage.setItem("USERNAME", null);
		sessionStorage.clear();
		}//end if
	
	if (queryStringParams.lnl)
		submitform1(null);
	else{
		document.getElementsByName('email')[0].focus();
		if (window.location.href=="http://localhost:3000/?drv=d")
			setCred((prev)=>{
				return {...prev, email:"addrianj@gmail.com", pwd:"pwd"}
				});
		}
		




},[]);


useEffect(() => {
	
	
	if (document.getElementById("btnpwd")){
	if (pwd.req1 && pwd.req2 && pwd.req3 && pwd.req4 && pwd.req5){
		if (document.getElementById("btnpwd").classList.contains("hidden"))
			document.getElementById("btnpwd").classList.remove("hidden");
		}//end if
	else{
		if (!document.getElementById("btnpwd").classList.contains("hidden"))
			document.getElementById("btnpwd").classList.add("hidden");
		}//end else
		
	}//end if
	
 },[pwd.req1, pwd.req2, pwd.req3, pwd.req4, pwd.req5]);
 
useEffect(() => {
	checkpassword();
	
 },[myprofile.password1,myprofile.password2]);



useEffect(() => {
	if (attemp.count>0)
		sessionStorage.setItem("ATTEMPT_COUNT", attemp.count);
	
 },[attemp.count]);



useEffect(() => {
	

	if (cred.eml_ver_code_sent==true){
		document.getElementsByName("email")[0].readOnly=true;
		document.getElementsByName("pwd")[0].readOnly=true;
		if (!document.getElementsByName("email")[0].classList.contains("gnsbro"))
			document.getElementsByName("email")[0].classList.add("gnsbro");
		if (!document.getElementsByName("pwd")[0].classList.contains("gnsbro"))
			document.getElementsByName("pwd")[0].classList.add("gnsbro");
		
		document.getElementsByName("eml_ver_code")[0].focus();
		
		}//end if
	else{
		document.getElementsByName("email")[0].readOnly=false;
		document.getElementsByName("pwd")[0].readOnly=false;
		if (document.getElementsByName("email")[0].classList.contains("gnsbro"))
			document.getElementsByName("email")[0].classList.remove("gnsbro");
		if (document.getElementsByName("pwd")[0].classList.contains("gnsbro"))
			document.getElementsByName("pwd")[0].classList.remove("gnsbro");
		}//end else
		
	
},[cred.eml_ver_code_sent]);



useEffect(() => {
	
	if (!document.getElementsByName("pwd")[0])
		return;
	
	if (cred.forgotpwd>0){
		document.getElementsByName("pwd")[0].required=false;
		document.getElementById("btnlogin").click();
		}
	else
		document.getElementsByName("pwd")[0].required=true;
		
	
},[cred.forgotpwd]);



useEffect(() => {
	
if (cred.aduserloggedin==true)
	getirdloginid();

},[cred.aduserloggedin]);


useEffect(() => {
	
	if (!document.getElementsByName("eml_ver_code")[0])
		return;
	
	if (cred.auth_count>0 && cred.trustcount==0)
		document.getElementsByName("eml_ver_code")[0].required=true;
	else
		document.getElementsByName("eml_ver_code")[0].required=false;
		
	//document.getElementsByName("eml_ver_code")[0].focus();
	
},[cred.auth_count, cred.trustcount]);

useEffect(() => {
	
	if (!document.getElementById("cbtrust"))
		return;

//console.log("cred.trust_this_device: "+cred.trust_this_device);
	
	if (cred.trust_this_device==1){
		if (!document.getElementById('lbltrust').classList.contains("bgpalegreen"))
			document.getElementById('lbltrust').classList.add("bgpalegreen");
		}//end if
	else{
		if (document.getElementById('lbltrust').classList.contains("bgpalegreen"))
			document.getElementById('lbltrust').classList.remove("bgpalegreen");
		}
		
	
},[cred.trust_this_device]);


useEffect(() => {
	
	if (cred.auth_count==null)
		return;

	if (cred.auth_count==0)
		document.getElementsByName('pwd')[0].focus();
	
},[cred.auth_count]);


useEffect(() => {
	
	if (cred.match_count==null)
		return;

	if (cred.match_count==0)
		document.getElementsByName('eml_ver_code')[0].focus();
	
},[cred.match_count]);


function clickregister(e){
e.preventDefault();
alert('registration will be available soon');
}//end func

function clickforgotpwd(e){
e.preventDefault();
setCred((prev)=>{
	return {...prev, forgotpwd:cred.forgotpwd+1}
});

}//end func

function clicklogin(e){
//e.preventDefault();
if (cred.forgotpwd>0)
	setCred((prev)=>{
		return {...prev, changepassword: true}
	});
	
setCred((prev)=>{
	return {...prev, forgotpwd:0}
});

}//end func

function handleChange(e){
let {name, value} = e.target;

if (cred.forgotpwd>0)
	setCred((prev)=>{
		return {...prev, changepassword: true}
	});


const isemail=(name=="email" && validEmail(value))?true:false;

	setCred((prev)=>{
		return {...prev, [name]:value, forgotpwd:0, isemail:isemail}
		});

}//end func



function validEmail(email){
  const regex = /^((?!\.)[\w\-_.]*[^.])(@\w+)(\.\w+(\.\w+)?[^.\W])$/;
  return regex.test(email);
}


async function getip(){
const requestOptions = {
  method: 'GET'
};

await fetch('https://api.ipify.org?format=json',requestOptions)
  .then(res => res.json())
  .then(res => aftergetip(res) )
  .catch(err => console.log(err));	
}//end func

function aftergetip(res){
setCred((prev)=>{ return {...prev,ip:res.ip} }) ;
}//end func


function getDeviceName(){
	
	var deviceName='';
    const UserAgent = navigator.userAgent;
    const device = {
        iPad: /iPad/.test(UserAgent),
        iPhone: /iPhone/.test(UserAgent),
        Android: /Android/.test(UserAgent),
        Windows: /Windows/.test(UserAgent)
    }

    for(var dev in device){
        if(device[dev])
        	deviceName = dev;
    }
    
setCred((prev)=>{
	return {...prev
	,"devicename":deviceName
	}
});

}//end func


/*
async function checkforgotpwdOld(){

const params={
	USERNAME:cred.email
	, IP:cred.ip
	, FORGOT_PWD: 1
	
	
	
	};

	
const requestOptions = {
	method: 'POST'
  ,headers: { 'Content-Type': 'application/json' }
  ,body: JSON.stringify( params )
  };

await fetch(resturl+'rarwplogin/loginweborgovtuser',requestOptions)
  .then(res => res.json())
  .then(res => aftercheckforgotpwd(res) )
  .catch(err => console.log(err));	
}//end func

*/


function aftercheckforgotpwdOld(res){
console.log("aftercheckforgotpwd: "+JSON.stringify(res));
const USER_COUNT=res.length?(res[0].USER_COUNT??0):0;
	
if (1*USER_COUNT==0)
	window.alert("the email address provided is not registered.");
else
	showsnackbar("please check your email inbox for single use password");
}//end func






async function loginweborgovtuser(){

if (attemp.count>12){
	window.alert("Too many failed logins.  contact admin");
	return;
	}

if (cred.forgotpwd>0){
	const conf_res = window.confirm("a verification code will be sent to your email inbox.  Ok?");
	if (!conf_res){
		setCred((prev)=>{
			return {...prev, forgotpwd:0}
			});
		return;
		}//end if
		
	}//end if

	
let trust_code=localStorage.getItem(cred.email+"@borderforceapps.gov.tc")??"";

const params={
	USERNAME: cred.email.trim()
	, PWD: md5(cred.pwd )
	, IP: cred.ip
	, FORGOT_PWD: cred.forgotpwd
	, DEVICE: cred.devicename
	, EML_VER_CODE: cred.eml_ver_code.trim()
	, TRUST_CODE: trust_code.trim()
	, TRUST_THIS_DEVICE: cred.trust_this_device
	};
	

//console.log(JSON.stringify(params));
	
const requestOptions = {
	method: 'POST'
  ,headers: { 'Content-Type': 'application/json' }
  ,body: JSON.stringify( params )
  };

classlist(document.getElementById("btnlogin"), "hidden", 1);
classlist(document.getElementById("btnforgotpwd"), "hidden", 1);

setDowait({show:true});

await fetch(resturl+'rarwplogin/loginweborgovtuser',requestOptions)
  .then(res => res.json())
  .then(res => afterloginweborgovtuser(res) )
  .catch(err => console.log(err));	
}//end func


function afterloginweborgovtuser(res){

setDowait({show:false});


classlist(document.getElementById("btnlogin"), "hidden", 0);
classlist(document.getElementById("btnforgotpwd"), "hidden", 0);


//console.log(JSON.stringify(res));

const USER_COUNT=res.length?(res[0].USER_COUNT??0):0;
const FAIL_COUNT=res.length?(res[0].FAIL_COUNT??0):0;
const AttemptCount=1*attemp.count;

if (FAIL_COUNT==0 || AttemptCount+1>FAIL_COUNT){
	setAttemp({count:AttemptCount+1});
	}
else 
	setAttemp({count:FAIL_COUNT});

//OTP_MATCH_COUNT
	
if (1*USER_COUNT==0){
	
	
		if (cred.isemail==true)
			window.alert("the email address provided is not registered.");
		else{
			/*if it is not an email do a secondary auth check*/
			callauthenc();
			
			}//end else	
	
	return;
	}

const EML_VRFY_CODE_LOG_ID= res.length? (res[0].EML_VRFY_CODE_LOG_ID??0) : 0;
if (EML_VRFY_CODE_LOG_ID>0){
	setCred((prev)=>{ return {...prev,eml_ver_code_sent:true} }) ;
	showsnackbar('please check your email inbox for verification code');
	document.getElementsByName("pwd")[0].focus();
	}//end if
else {
	
	const OTP_MATCH_COUNT= res.length? (res[0].OTP_MATCH_COUNT??"") : "";
	
	if (OTP_MATCH_COUNT=="0"){
		alert("The email verification code given is not correct");
		return;
		}
	
	const NEW_TRUST_CODE= res.length? (res[0].NEW_TRUST_CODE??"") : "";
	if (NEW_TRUST_CODE!=""){
		localStorage.setItem(cred.email+"@borderforceapps.gov.tc", NEW_TRUST_CODE);
		console.log("trust_code "+NEW_TRUST_CODE+" written to localStorage");
		}//end if
	
	
	let AUTH_COUNT= res.length? (res[0].AUTH_COUNT??0) : 0;
	
	//OTP_MATCH_COUNT is 0 if bad EML_VER_CODE was sent.  Otherwise empty or 1
	//OTP_MATCH_COUNT is 0 should override AUTH_COUNT
	if (OTP_MATCH_COUNT=="0")
		AUTH_COUNT=0;
	else if (AUTH_COUNT==0 && OTP_MATCH_COUNT=="1")
		AUTH_COUNT=1;
	//OTP_MATCH_COUNT may result 1 after matching ev_code, and auth_count=0, over-ride so set auth_count=1

	//showsnackbar("please check your email inbox for single use password");
	console.log("cred.changepassword: "+cred.changepassword);

	if (AUTH_COUNT>0){
		if (cred.changepassword==true){
			setLogininfo(res[0]);
			toggleModalsm();
			if (document.getElementsByName("password1")[0])
				document.getElementsByName("password1")[0].focus();
			}//end if
		else{
			loginuser(res[0]);
			}//end else
		}//end if
	else{
		if (cred.isemail==true)
			window.alert("Login Failed");
		else{
			/*if it is not an email do a secondary auth check*/
			callauthenc();
			
			}//end else
		
		} //end else
		
	}//end else
	
}//end func


function formatDate(date) {
	
	
	function dateComponentPad(value) {
  var format = String(value);

  return format.length < 2 ? '0' + format : format;
}
	
	
  var datePart = [ date.getFullYear(), date.getMonth() + 1, date.getDate() ].map(dateComponentPad);
  var timePart = [ date.getHours(), date.getMinutes(), date.getSeconds() ].map(dateComponentPad);

  return datePart.join('-') + ' ' + timePart.join(':');
}//end func

function loginuser(datarow){
	
	
	for(var attributename in datarow){
		const data=datarow[attributename]??"";
		sessionStorage.setItem(attributename, data);
		}//end for	
	
	console.log("sess AUTH_COUNT: "+sessionStorage.getItem("AUTH_COUNT")??"");
	console.log("sess TRUST_COUNT: "+sessionStorage.getItem("TRUST_COUNT")??"");
	console.log("sess START_PAGE: "+sessionStorage.getItem("START_PAGE")??"");

	getSessionvars();	
}//end func



async function getSessionvars(){
const requestOptions = {
  method: 'GET'
};

await fetch(resturl+'rarwplogin/getsessionvars',requestOptions)
  .then(res => res.json())
  .then(res => aftergetSessionvars(res) )
  .catch(err => console.log(err));	
}//end func

async function aftergetSessionvars(res){
//console.log('aftergetSessionvars: '+JSON.stringify(res));
//console.log('aftergetSessionvars res.length: '+res.length);
res.map((col, index) => {
	let val=col['VAL']?col['VAL']:"";
	if (val.toLowerCase()=="null" || val.toLowerCase()=="undefined")
		val="";
	sessionStorage.setItem(col['SESSION_VAR'], val);
	console.log(col['SESSION_VAR']+", "+val);
});		


setFixedSessionItems();

let start_page=sessionStorage.getItem("START_PAGE")??"";

if (start_page=="")
	start_page = "dashboard";

if (cred.promptchgpwd==true)
	start_page="myprofile";

console.log("start_page: "+start_page);
//setFixedSessionItems();

/*
	if (cred.cbtrust==1)
		getDeviceName();
	else 
*/
		navigate("/"+start_page);


}//end func

function setFixedSessionItems(){
/*
after login success have a loop to set fixed sessionStorage items to "" if they undefined or null
e.g. IRD_LOGIN_ID, AD_USER
*/
	const arrItm="NEW_EMAIL,IRD_LOGIN_ID,AD_USER,TRUSTED_DEVICE,SUP_PVG,TC_ISLAND,PROCESS_AREA,START_PAGE,SHARED_FOLDER".split(",");
	for (var i=0; i<arrItm.length; i++){
		const itm=arrItm[i];
		const currGetItem = ""+(sessionStorage.getItem(itm)??"");
		
		if (currGetItem=="" || currGetItem.toLowerCase().trim()=="null")
			sessionStorage.setItem(itm, "");
		}//end for

	//replace "null" with "" in items
	for (var i = 0; i < sessionStorage.length; i++){
		const key=sessionStorage.key(i);
		//check for null or "null" but no need to check undefined
		if (sessionStorage.getItem(key)==null)
			sessionStorage.setItem(key, "");
		else if (sessionStorage.getItem(key).toLowerCase().trim()=="null")
			sessionStorage.setItem(key, "");
		
		}//end for

}//end func



async function updatepassword(){

if (!pwd.req1 || !pwd.req2 || !pwd.req3 || !pwd.req4 || !pwd.req5){
	window.alert("requirments are not met!");
	return;
	}

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {email: cred.email, pwd:md5(myprofile.password1)} )
  };		

  await fetch(resturl+'rarwplogin/updatepassword',requestOptions)
      .then(res => res.json())
      .then(res => 	afterupdatepassword(res) )
      .catch(err => console.log(err));

}//end func

function afterupdatepassword(res){
	let EMAIL_COUNT=0;
	if (res.length)
		if (res.length==1)
			EMAIL_COUNT=res[0].EMAIL_COUNT;

if (EMAIL_COUNT==0)
	window.alert("that failed!");
else{
	window.alert("your password was updated");
	//navigate("/login");
	//disablecredinputs(0);
	setCred((prev)=>{ return {...prev, pwd:"", eml_ver_code:"", changepassword:false, eml_ver_code_sent:false} }) ;
	toggleModalsm();
	document.getElementsByName("pwd")[0].focus();
	//loginuser(Logininfo);
	}
	

}//end func


function myprofileChange(e){
	const {name, value}=e.target;
//console.log("handleChange name: "+name+" -> "+value);	
//document.getElementById('btnsave').style.visibility='visible';
setMyprofile((prev)=>{
	return {...prev, [name]:value}
});

	

}//end func


function toggleModalsm() {
const modalsm = document.querySelector(".modalsm");

	
console.log('modalsm is null: '+(modalsm==null));
modalsm.classList.toggle("show-modalsm");

if (document.querySelector(".close-button")){
	const closeButton = document.querySelector(".close-button");
	if(!closeButton.classList.contains('attached-listener')){
		closeButton.classList.add('attached-listener');
		closeButton.addEventListener("click", toggleModalsm);
		window.addEventListener("click", windowOnClick);
		}//end if
	}//end if
return false;
}//end func

function windowOnClick(event) {
const modalsm = document.querySelector(".modalsm");
	
console.log('event.target === modalsm: '+(event.target === modalsm));
	
    if (event.target === modalsm) {
    	toggleModalsm();
    }
}//end func


function disablecredinputs(disable){
	
if (disable==1){
	document.getElementsByName("email")[0].readOnly=true;
	if (!document.getElementsByName("email")[0].classList.contains("gnsbro"))
		document.getElementsByName("email")[0].classList.add("gnsbro");

	document.getElementsByName("pwd")[0].readOnly=true;
	if (!document.getElementsByName("pwd")[0].classList.contains("gnsbro"))
		document.getElementsByName("pwd")[0].classList.add("gnsbro");
	}//end if
else {
	document.getElementsByName("email")[0].readOnly=false;
	if (document.getElementsByName("email")[0].classList.contains("gnsbro"))
		document.getElementsByName("email")[0].classList.remove("gnsbro");

	document.getElementsByName("pwd")[0].readOnly=false;
	if (document.getElementsByName("pwd")[0].classList.contains("gnsbro"))
		document.getElementsByName("pwd")[0].classList.remove("gnsbro");
	}//end if
	
}//end func

function setSessionvars(res){
for (var i=0; i<res.length; i++){
	sessionStorage.setItem(res[i].sessvar, res[i].valu);
	}//end for
console.log("setSessionvars REST_URL:"+sessionStorage.getItem("REST_URL"));
}//end func

function showsnackbar(innerHTML) {
  var x = document.getElementById("snackbar");
  x.innerHTML=innerHTML;
  x.className = "show";
  setTimeout(function(){ x.className = x.className.replace("show", ""); }, 5000);
}//end func


async function submitform1(e){
if (e)
	e.preventDefault();

console.log("submitform1 cred.forgotpwd: "+cred.forgotpwd);

	
if (queryStringParams.lnl){
	checkadulanlogin();
	}//end if
else
	loginweborgovtuser();
	


}//end func

function classlist(elem, cls, add){

if (!elem)
	return;

if (add==1){
	if (!elem.classList.contains("hidden"))
		elem.classList.add("hidden");
	}//end if
else{
	if (elem.classList.contains("hidden"))
		elem.classList.remove("hidden");
	}//end else
}//end func




async function checkadulanlogin(){

const params={
	lanlogin: queryStringParams.lnl
	};


		const requestOptions = {
		  method: 'POST'
		  ,headers: { 'Content-Type': 'application/json' }
		  ,body: JSON.stringify( params )
	  };
setDowait({show:true});

	 await fetch(customspremurl+'rarlogin/checkadulanlogin',requestOptions)
		  .then(res => res.json())
		  .then(res => aftercheckadu(res, true))
		  .catch(err => console.log(err));

}//end func


function aftercheckadu(res, lanlogin){
//when lanlogin is true we should set the cred.username on the form
//similar to afterloginwebuser but modified for AD_USER
setDowait({show:false});

let EMAIL_COUNT=0, AUTH_COUNT=0, AD_USER="";
sessionStorage.setItem("AD_USER", "");
if (res.length)
	if (res.length==1){
		EMAIL_COUNT=res[0].EMAIL_COUNT;
		AUTH_COUNT=res[0].AUTH_COUNT;
		AD_USER=res[0].AD_USERNAME;
		//change username to email address if login via ad user
		//username=res[0].GOV_TC_EMAIL?res[0].GOV_TC_EMAIL:cred.username;
		}//end if

console.log("AUTH_COUNT: "+AUTH_COUNT);
console.log("AD_USER: "+AD_USER);
		
if (AUTH_COUNT==0){
	showsnackbar("login failed!");
	setCred((prev)=>{
		return {...prev, authfailed:true}
	});
	}//end if
else if (AUTH_COUNT==1){
	sessionStorage.setItem("AD_USER", AD_USER);
	setCred((prev)=>{
		return {...prev, username:AD_USER, aduserloggedin:true}
		})//end if
	}//end else
			

		

	
}//end func


function getBrowserName() {
    var userAgent = navigator.userAgent;
    var browser_names = ['Firefox', 'Chrome', 'Safari', 'Edge', 'Opera', 'MSIE', 'OPR', 'Trident/']
    var browser_name = "Unknown Browser"

    for (let i = 0; i < browser_names.length; i++) {
      if (userAgent.indexOf(browser_names[i]) > -1) {
          browser_name = browser_names[i]
          return browser_name
      }
    }
	setCred({browser_name:browser_name});
	
    return browser_name
}//end func








function getirdloginid(){
		console.log("getirdloginid username: "+cred.username);
   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {USERNAME:cred.username} )
  };	
	setDowait({show:true});
  fetch(resturl+'rarwpform/getirdloginid',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetirdloginid(res) )
      .catch(err => console.log(err));

	//console.log('aftergetwpapp: '+res[0].OCCUPATION);
}//end func

function aftergetirdloginid(res){
	setDowait({show:false});
if (res.length==undefined)	
	sessionStorage.setItem("IRD_LOGIN_ID", "");
else
	sessionStorage.setItem("IRD_LOGIN_ID", res[0].IRD_LOGIN_ID);

insertloginlog();
}//end func


async function insertloginlog(){

/*
21Nov2024 IMPORTANT
do not use cred.username below.
becuase there is a call via tv arg url such as below. 
where the username is passed in the url and absent in cred.username
localhost:3000/?id=ajones&tv=625
*/
const jsonObj={
	AD_USERNAME:cred.username
	,IP:cred.ip
	};


		const requestOptions = {
		  method: 'POST'
		  ,headers: { 'Content-Type': 'application/json' }
		  ,body: JSON.stringify( jsonObj )
	  };
setDowait({show:true});

	await  fetch(resturl+'rarwplogin/insertloginlog',requestOptions)
		  .then(res => res.json())
		  .then(res => afterinsertloginlog(res))
		  .catch(err => console.log(err));

}//end func


function afterinsertloginlog(res){
	console.log("afterinsertloginlog: "+JSON.stringify(res));
	setDowait({show:false});

	if (res.length){
		sessionStorage.setItem("USERNAME", res[0].USERNAME?? "" );
		sessionStorage.setItem("EMAIL", res[0].EMAIL?? "");
		sessionStorage.setItem("NUM_ROLES", res[0].NUM_ROLES?? "");
		sessionStorage.setItem("CASE_WORKER", res[0].CASE_WORKER?? "");
		sessionStorage.setItem("PROCESS_AREA", res[0].PROCESS_AREA?? "");
		sessionStorage.setItem("TC_ISLAND", res[0].TC_ISLAND?? "");
		sessionStorage.setItem("SUP_PVG", res[0].SUP_PVG?? "");
		sessionStorage.setItem("START_PAGE", res[0].START_PAGE?? "");
		sessionStorage.setItem("USER_ROLES", res[0].SUP_PVG?? "");
		getSessionvars();
		}//end if
	else
		showsnackbar("an error occured.  please try again or contact admin.");


/*
if (sessionStorage.getItem("AD_USER")!=undefined || VERIFY_DATE_COUNT>0){
	sessionStorage.setItem("USERNAME", res[0].USERNAME );
	sessionStorage.setItem("EMAIL", res[0].EMAIL);
	sessionStorage.setItem("NUM_ROLES", res[0].NUM_ROLES);
	sessionStorage.setItem("CASE_WORKER", res[0].CASE_WORKER);
	getSessionvars();
	//sessionStorage.setItem("VERIFY_DATE", res[0].VERIFY_DATE);
	}
else if (VERIFY_DATE_COUNT==0){
	//sessionStorage.setItem("USERNAME", USERNAME );
	navigate("./webreg",{state:{EMAIL:res[0].USERNAME, RESTURL:resturl} });
	}//end if

*/
	
}//end func




async function clickCbtrust(e){
	//console.log("clickCbtrust: "+e.target.checked);
setCred((prev)=>{
	return {...prev, trust_this_device:e.target.checked?1:0}
	});
}//end func



function checkpassword() {
	//copied from myprofile page
  var strength = 0;
  /*
  len, capital, common, number, match
  */
  const pwd1=(""+myprofile.password1).trim();
  const pwd2=(""+myprofile.password2).trim();
  //console.log("pwd1: "+pwd1);Holiday1
  //console.log("pwd2: "+pwd2);
  setPwd((prev)=>{
	  return {...prev
	  , req1: pwd1.length>7 && pwd1.length<31
	  , req2: pwd1.match(/[A-Z]+/)
	  , req3: pwd1.match(/[a-z]+/)
	  , req4: pwd1.match(/[0-9]+/)
	  , req5: (pwd1!="" && pwd1==pwd2)
	  }
  });
  
  


}//end func
	
	
async function callauthenc(){

let SSNSTARTS = sessionStorage.getItem("SSNSTARTS")??"";

if (SSNSTARTS==""){
	SSNSTARTS = formatDate(new Date());
	sessionStorage.setItem("SSNSTARTS", SSNSTARTS);
	}//end func

const SSNCRIT = sessionStorage.getItem("SSNCRIT")??"";
const ip = cred.ip==""?"127.0.0.1":cred.ip;

//console.log("callauthenc SSNCRIT: "+SSNCRIT);

const params={
	STAMP: SSNSTARTS
	, username: (SSNCRIT=="")? "" : CryptoJS.AES.encrypt(cred.email, SSNCRIT).toString()
	, password: (SSNCRIT=="")? "" : CryptoJS.AES.encrypt(cred.pwd, SSNCRIT).toString()
	, ip: cred.ip
	};

   const requestOptions = {
	  method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		
  await fetch(customspremurl+'rarauthadng/authenc',requestOptions)
	  .then(res => res.json())
	  .then(res => 	aftercallauthenc(res, SSNCRIT, ip) )
	  .catch(err => console.log(err));
	
}//end func

async function aftercallauthenc(res, SSNCRIT, ip){
if (SSNCRIT==""){
	const CRIT = res.length?(res[0].STAMP??""):"";

	if (CRIT=="")
		window.alert("could not register session for criteria");
	else{
		const jsonObj=JSON.parse(decrypt(CRIT, ip));
		SSNCRIT = jsonObj.plainText??"";
		//console.log("SSNCRIT: "+SSNCRIT);
		sessionStorage.setItem("SSNCRIT", SSNCRIT );		
		callauthenc();
		}//end else
	return;
	}
else{
	const auth_count=res.length?(res[0].auth_count??0):0;
	if (auth_count==0)
		window.alert("login failed");
	else
		updateaduser();
		//loginweborgovtuser();
	}//end else

}//end func


async function updateaduser(){

const SSNSTARTS = sessionStorage.getItem("SSNSTARTS")??"";
const SSNCRIT = sessionStorage.getItem("SSNCRIT")??"";

const params={
	STAMP: SSNSTARTS
	, username: cred.email
	, password: CryptoJS.AES.encrypt(cred.pwd, SSNCRIT).toString()
	, ip: cred.ip
	};

		const requestOptions = {
		  method: 'POST'
		  ,headers: { 'Content-Type': 'application/json' }
		  ,body: JSON.stringify( params )
	  };
setDowait({show:true});

	await  fetch(resturl+'rarwplogin/updateaduser',requestOptions)
		  .then(res => res.json())
		  .then(res => afterupdateaduser(res))
		  .catch(err => console.log(err));

}//end func


function afterupdateaduser(res){
setDowait({show:false});
const UPDATE_COUNT=res.length?(res[0].UPDATE_COUNT??0):0;
if (UPDATE_COUNT==0)
	window.alert("attempt to update credentials failed");
else
	loginweborgovtuser();

}//end func

function decrypt(encrypted_item, CRIT){
	
const bytes = CryptoJS.AES.decrypt(encrypted_item , CRIT)	;
//const decryptData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
const decryptData = bytes.toString(CryptoJS.enc.Utf8);
//conslog('decryptData: '+decryptData);
return decryptData;
}//end function






	
  return (
  <>
  

  
  <form id="loginform" method="POST" onSubmit={(e)=>{submitform1(e);}} style={{ width:"97%",marginTop:"18px",marginLeft:"auto",marginRight:"auto"}} >
  
  <div align="center"  className="numcols2-1"  style={{backgroundColor:""}} >
	<img src='img/logo_immigration.png'  height="140" alt="login form"  border="0"  style={{marginTop:"18px"}} />
	</div>
	
	<div align="center"  id="logindiv" className="numcols2-2"  style={{backgroundColor:"aliceblue"}} >

		<table align="center" id="tbllogin" border="0" width="100%"  style={{marginTop:"18px", marginBottom:"18px"}} >
		<tbody>
		
			<tr>
				<td align="center" >
			  	<span className='bannertextlarge'>Application Processing System</span>
				<div className='bannertextsmall' style={{marginBottom:"24px"}} >Ministry of Immigration and Border Services<br/>Turks and Caicos Islands Government<br/>{cred.browser_name}</div>
				</td>
			</tr>
		
	

			<tr>
				<td align="center" >
				
					<div className="floating-form">
					  <div className="floating-label">
						<input name="email" onChange={(e)=>{handleChange(e);}} value={cred.email}  required type='text'  onFocus={(e)=>{e.target.select();}}  className="floating-input"  placeholder=" "   />
						<span className="highlight"></span>
						<label className="loginlabel" >Email address or Username</label>
					  </div>
					 </div>

				</td>
			</tr>
			<tr>
				<td align="center" >
					<div className="floating-form">
					  <div className="floating-label">
						<input name="pwd" onChange={(e)=>{handleChange(e);}} value={cred.pwd}  required type='password'  onFocus={(e)=>{e.target.select();}}  className="floating-input"  placeholder=" "   />
						<span className="highlight"></span>
						<label className="loginlabel" >Password</label>
					  </div>
					 </div>
					 
				</td>
			</tr>
				
				{
				cred.eml_ver_code_sent==true && <>
				<tr>
					<td align="center" >
					<div className="floating-form">
					  <div className="floating-label">
						<input name="eml_ver_code" onChange={(e)=>{handleChange(e);}} value={cred.eml_ver_code}  required type='text'  onFocus={(e)=>{e.target.select();}}  className="floating-input"  placeholder=" "   />
						<span className="highlight"></span>
						<label className="loginlabel" >Email Verification Code</label>
					  </div>
					 </div>				
					<input type='checkbox' id='cbtrust'  onClick={(e)=>{clickCbtrust(e);}} />
					<label id='lbltrust' className="hand" htmlFor='cbtrust' >&nbsp;Do not verify again on this web browser</label>
					</td>
				</tr>
				</>
				}

			<tr>
				<td align="center" >
					{
					!dowait.show && 
					<button className="button" id="btnlogin" >Login</button>
					}
					{dowait.show && <span><img src='img/Loading_2.gif' border='0' height='36' /> . . . please wait</span>}

				</td>
			</tr>
			<tr>
				<td align="center" >
					{
					cred.eml_ver_code_sent==false && 
					<a href="#" id="btnforgotpwd" onClick={(e)=>{clickforgotpwd(e);}} >Forgot password?</a>
					}
					  <p >Do not have an account? 
					  <a href="#" className="nodecor" style={{color: '#393f81'}} onClick={(e)=>{e.preventDefault(); navigate("/webreg", {state:{RESTURL:resturl, EMAIL:cred.username}});}} > Register here</a>
					{/*<a href="#"  onClick={(e)=>{clickregister(e);}} style={{color: '#393f81'}}>Register here</a>*/}
					  </p>
				</td>
			</tr>
		  <tr>
		  <td align="center" ><a href="download/How to register and upload a work permit application on APS portal.pdf" target="_blank" className="nodecor" ><img src="img/pdf.gif" border="0" /> guide to getting started</a></td>
		  </tr>
		  <tr>
		  <td align="center" >Attempts: <input name="count" value={attemp.count} size="1" style={{textAlign:"center"}} readOnly className="gnsbro" /></td>
		  </tr>

		</tbody>
		</table>
			
	</div>
	</form>
	
	
<div className="modalsm">
    <div className="modalsm-content">
        <span className="close-button">&times;</span>
        <div  id='modalsmtext' >
		<div align="left" >
		<p align="center" className="Acme" style={{marginBottom:"6px", marginTop:"9px", color:"brown",fontSize:"24px"}} >Update your password</p>	
		
		please note the password requirements:
		<br/>(i)  The password length is between 8 and 30 &nbsp;{pwd.req1 && <img src="img/greentick.png" height="14" border="0" />}
		<br/>(ii)  The password contains at least 1 Capital letter &nbsp;{pwd.req2 && <img src="img/greentick.png" height="14" border="0" />}
		<br/>(ii)  The password contains at least 1 Common letter &nbsp;{pwd.req3 && <img src="img/greentick.png" height="14" border="0" />}
		<br/>(iii)  The password contains at least 1 number &nbsp;{pwd.req4 && <img src="img/greentick.png" height="14" border="0" />}
		<br/>(iv)  The two inputs contain the same password &nbsp;{pwd.req5 && <img src="img/greentick.png" height="14" border="0" />}
		{/*<br/>(iv)  The password contains at least 1 of these special characters: $@#&!*/}
		</div>
		<table align="center">
		<tbody>
		<tr>
			<td align="right" >enter password:</td>
			<td align="left" ><input name="password1" type="password" value={myprofile.password1} onChange={(e)=>{myprofileChange(e);}} autoComplete="off" onFocus={(e)=>{e.target.select();}} /></td>
		</tr>
		<tr>
			<td align="right" >re-enter password:</td>
			<td align="left" ><input name="password2" type="password" value={myprofile.password2} onChange={(e)=>{myprofileChange(e);}} autoComplete="off" onFocus={(e)=>{e.target.select();}}  onPaste={(e)=>{e.preventDefault(); e.target.value=""}} /></td>
		</tr>
		<tr>
			<td align="right" >&nbsp;</td>
			<td align="left" ><button className="button hidden" id="btnpwd" onClick={(e)=>{updatepassword();}} >save the password</button></td>
		</tr>
		</tbody>
		</table>
		</div>
		
    </div>
</div>	
	
	<div id='snackbar' ></div>
	</>
  );
}

export default LoginPage;